import {
    NEW_TABELA_TRIBUTARIA_SUCCESS,
    CANCEL_TABELA_TRIBUTARIA_RAPIDO,
    CANCEL_TABELA_TRIBUTARIA_RAPIDO_SUCCESS,
    TABLE_TABELA_TRIBUTARIA_PENDING,
    TABLE_TABELA_TRIBUTARIA_SUCCESS,
    TABLE_TABELA_TRIBUTARIA_FAILURE,
    LIST_TABELA_TRIBUTARIA_PENDING,
    LIST_TABELA_TRIBUTARIA_SUCCESS,
    LIST_TABELA_TRIBUTARIA_FAILURE,
    FIND_TABELA_TRIBUTARIA_PENDING,
    FIND_TABELA_TRIBUTARIA_SUCCESS,
    FIND_TABELA_TRIBUTARIA_FAILURE,
    DELETE_TABELA_TRIBUTARIA_PENDING,
    DELETE_TABELA_TRIBUTARIA_SUCCESS,
    DELETE_TABELA_TRIBUTARIA_FAILURE,
    CREATE_TABELA_TRIBUTARIA_PENDING,
    CREATE_TABELA_TRIBUTARIA_SUCCESS,
    CREATE_TABELA_TRIBUTARIA_FAILURE,
} from './actionTypes';


const initialState = { list: null, loading: false }


function tabelaTributariaReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_TABELA_TRIBUTARIA_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: action.isCadastroRapido ?? false,
            }
        case LIST_TABELA_TRIBUTARIA_PENDING:
        case FIND_TABELA_TRIBUTARIA_PENDING:
        case DELETE_TABELA_TRIBUTARIA_PENDING:
        case CREATE_TABELA_TRIBUTARIA_PENDING:
        case TABLE_TABELA_TRIBUTARIA_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CANCEL_TABELA_TRIBUTARIA_RAPIDO:
        case CANCEL_TABELA_TRIBUTARIA_RAPIDO_SUCCESS:
            return {
                ...state,
                isCadastroRapido: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case LIST_TABELA_TRIBUTARIA_SUCCESS:
            return {
                ...state,
                list: action.list,
                loading: false
            }
        case LIST_TABELA_TRIBUTARIA_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case TABLE_TABELA_TRIBUTARIA_SUCCESS:
            return {
                ...state,
                table: action.table,
                loading: false
            }
        case TABLE_TABELA_TRIBUTARIA_FAILURE:
            return {
                ...state,
                table: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_TABELA_TRIBUTARIA_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_TABELA_TRIBUTARIA_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_TABELA_TRIBUTARIA_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_TABELA_TRIBUTARIA_SUCCESS:
        case CREATE_TABELA_TRIBUTARIA_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: false,
            }
        case DELETE_TABELA_TRIBUTARIA_FAILURE:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { tabelaTributariaReducer };